import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children"];
import React from 'react';
import { Menu } from 'semantic-ui-react';
import { ChildrenPropType } from '../../../../../../services/proptypes';
import useSemanticUiProps from '../../../../../foundation/hooks/use-semantic-ui-props/use-semantic-ui-props';
var defaultProps = {};
export default function Item(_ref) {
  var children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useSemanticUiProps = useSemanticUiProps(),
    getMenuItemProps = _useSemanticUiProps.getMenuItemProps;
  var menuItemProps = getMenuItemProps(props);
  return /*#__PURE__*/React.createElement(Menu.Item, menuItemProps, children);
}
Item.defaultProps = defaultProps;